import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet-async";

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [semester, setSemester] = useState('20251'); // Set default semester
  const [error, setError] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false); // Tambahkan state untuk loading

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); // Aktifkan loading saat mulai login
    setError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/users/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ phonenumber: username, password, semester }),
      });
      const result = await response.json();      
      console.log(result.message)

      if (!response.ok) {
        throw new Error(result.message);
      }
     

      localStorage.setItem('authToken', result.token);

      navigate("/admin");
      window.location.reload();
    } catch (err) {
      if (err.response) {
          // Server mengembalikan response tetapi dengan error (misalnya 401, 404, dll)
          console.log("Response error:", err.response.data);
          setError(err.response.data.message);
      } else if (err.request) {
          // Request dikirim, tetapi tidak ada respons dari server
          console.log("No response received:", err.request);
          setError('Server tidak merespons. Periksa Koneksi.');
      } else {
          // Terjadi error lain saat menyiapkan request
          console.log("Request error:", err.message);
          setError(err.message);
      }
  
    } finally {
      setLoading(false); // Matikan loading setelah selesai
    }
  };

  return (
    <>
    <Helmet>
      <title>Login Griya Vidya</title>
    </Helmet>
    <div className="auth-main">
      <div className="auth-wrapper v3">
        <div className="auth-form">
          <div className="card my-5">
            <div className="card-body">
              <a href="#" className="d-flex justify-content-center">
                <img src="/assets/images/logogvfix.png" width={200} alt="image" className="img-fluid brand-logo" />
              </a>
              <div className="row">
                <div className="d-flex justify-content-center">
                  <div className="auth-header">
                    <h2 className="text-secondary mt-5"><b>Hi, Selamat Datang</b></h2>
                    <p className="f-16 mt-2">Masukkan Nomor WhatsApp</p>
                  </div>
                </div>
              </div>
              <form onSubmit={handleLogin}>
                <div className="form-floating mb-3">
                  <input
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="form-control"
                    id="wanumber"
                    placeholder="Nomor WhatsApp"
                    required
                    disabled={loading} // Disable input saat loading
                  />
                  <label htmlFor="wanumber">Nomor WhatsApp</label>
                </div>

                <div className="form-floating mb-3">
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="form-control"
                    id="password"
                    placeholder="Password"
                    required
                    disabled={loading} // Disable input saat loading
                  />
                  <label htmlFor="password">Password</label>
                </div>

                <div className="form-floating mb-3">
                  <select
                    id="inputState"
                    className="form-select"
                    value={semester}
                    onChange={(e) => setSemester(e.target.value)}
                    disabled={loading} // Disable input saat loading
                  >
                    <option value="20251">2024 - 2025 Genap</option>
                    <option value="202511">2024 - 2025 Ganjil</option>
                    <option value="20242">2023 - 2024 Genap</option>
                    <option value="20241">2023 - 2024 Ganjil</option>
                  </select>
                  <label htmlFor="inputState">Semester</label>
                </div>

                <div class="d-flex mt-1 justify-content-between">
                <div class="form-check">
                
                </div>
                <h5 class="text-secondary"><a href='/lupapassword'>Lupa Password?</a></h5>
              </div>
                {error && <p className="text-danger text-center">{error}</p>}
                <div className="d-grid mt-4">
                  <button type="submit" className="btn btn-secondary" disabled={loading}>
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Logging in...
                      </>
                    ) : (
                      "Sign In"
                    )}
                  </button>
                </div>
              </form>

              <hr />
              <h5 className="d-flex justify-content-center">
                Belum Memiliki Akun? <a href='/daftar'>Daftar</a>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Login;
